export default __webpack_public_path__ + "static/media/thumbnail4.c4bf1577.jpg";